import React, { Component, PropTypes } from 'react';
import {
  Paper,
  List,
  ListItem,
  ListDivider,
  Toolbar,
  Styles,
  TextField,
  IconButton
} from 'material-ui';
import ScrollableContainer from 'components/ScrollableContainer';
import { FormattedMessage } from 'react-intl';
import * as Icons from 'components/Material/SvgIcons';
import * as Colors from 'components/Material/Styles/Colors';
import Loader from 'components/Material/Loader';

let { Spacing } = Styles;
let listStyle = {
  marginTop: Spacing.desktopGutter,
  boxSizing: 'border-box'
};

export default class ListSelector extends Component {
  static contextTypes = {
    muiTheme: PropTypes.object,
    getIntlMessage: PropTypes.func
  };

  static propTypes = {
    labelProperty: PropTypes.string,
    idProperty: PropTypes.string,
    items: PropTypes.array,
    selected: PropTypes.array,
    initialItemCount: PropTypes.number,
    loading: PropTypes.bool,
    searchHint: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  };

  static defaultProps = {
    labelProperty: 'name',
    idProperty: 'id',
    initialItemCount: 25,
    items: [],
    searchHint: 'Search',
    height: 400
  };

  constructor() {
    super(...arguments);
    let selected = {};
    let { idProperty, initialItemCount } = this.props;
    if (this.props.selected) {
      this.props.selected.forEach(item => {
        selected[item[idProperty]] = item;
      });
    }
    this.state = {
      maxItems: initialItemCount,
      searchText: null,
      selected
    };
  }

  getSelected() {
    return this.state.selected;
  }

  _onSelect(selected) {
    if (this.props.onSelect) {
      this.props.onSelect(selected);
    }
  }

  onScrollToBottom() {
    if (this._scrollTimeout) {
      clearTimeout(this._scrollTimeout);
    }
    this._scrollTimeout = setTimeout(() => {
      if (this.state.maxItems <= this.props.items.length) {
        this.setState({ maxItems: this.state.maxItems + 10 });
      }
    }, 100);
  }

  selectAll() {
    let { items, idProperty, labelProperty } = this.props,
      selected = {},
      { searchText } = this.state,
      regexp;
    if (searchText && searchText !== '') {
      regexp = new RegExp(searchText, 'i');
    }

    items
      .filter(item => {
        return item[idProperty] && this.filter(item, regexp, labelProperty);
      })
      .forEach(item => {
        if (item[idProperty]) {
          selected[item[idProperty]] = item;
        }
      });
    this.setState({ selected });
    this._onSelect(selected);
  }

  clearSelection() {
    this.setState({ selected: {} });
    this._onSelect({});
  }

  reset() {
    this.setState({ selected: {} });
  }

  selectItem(item) {
    let { selected } = this.state,
      { idProperty } = this.props;
    if (selected[item[idProperty]]) {
      delete selected[item[idProperty]];
    } else {
      selected[item[idProperty]] = item;
    }
    this.setState({ selected });
    this._onSelect(selected);
  }

  filter(item, regexp, labelProperty) {
    if (regexp && regexp !== '') {
      return item[labelProperty].search(regexp) > -1;
    } else {
      return true;
    }
  }

  changeSearchText() {
    if (this._changeSearchTimeout) {
      clearTimeout(this._changeSearchTimeout);
    }
    this._changeSearchTimeout = setTimeout(() => {
      this.setState({ searchText: this.refs.searchField.getValue() });
    }, 100);
  }

  render() {
    let { items, idProperty, labelProperty, loading } = this.props,
      children = [],
      theme = this.context.muiTheme,
      { searchText } = this.state,
      regexp;
    let selectedCount = Object.keys(this.state.selected).length;
    let toolbar = (
      <div
        style={{
          padding: Spacing.desktopGutterMini,
          borderStyle: 'none none solid none',
          borderColor: this.context.muiTheme.rawTheme.palette.borderColor,
          borderWidth: 1,
          backgroundColor: Colors.Colors.fullWhite
        }}
      >
        <TextField
          fullWidth={true}
          floatingLabelText={this.props.searchHint}
          ref="searchField"
          onChange={this.changeSearchText.bind(this)}
        />
      </div>
    );

    let list;
    if (loading) {
      list = <Loader />;
    } else {
      if (searchText && searchText !== '') {
        regexp = new RegExp(searchText, 'i');
      }

      items = items
        .filter(item => {
          return item[idProperty] && this.filter(item, regexp, labelProperty);
        })
        .splice(0, this.state.maxItems);
      children.push(<ListDivider key={'d-0'} />);
      items.forEach(item => {
        let label = item[labelProperty],
          id = item[idProperty],
          style = {},
          selected = this.state.selected && this.state.selected[id];
        if (id) {
          if (selected) {
            style.backgroundColor = this.context.muiTheme.rawTheme.palette.primary3Color;
            style.color = this.context.muiTheme.rawTheme.palette.primary3TextColor;
          }
          children.push(
            <ListItem
              onTouchTap={this.selectItem.bind(this, item)}
              style={style}
              key={'i-' + id}
              primaryText={label}
            />
          );
          children.push(<ListDivider key={'d-' + id} />);
        }
      });
      list = (
        <div style={listStyle}>
          <List>{children}</List>
        </div>
      );
    }

    let buttonStyle = {
      border: 'none',
      padding: 4,
      width: 32,
      height: 32
    };
    return (
      <Paper
        zDepth={0}
        style={{
          borderStyle: 'solid',
          borderWidth: 1,
          borderColor: theme.rawTheme.palette.borderColor
        }}
      >
        <ScrollableContainer
          header={toolbar}
          headerHeight={90}
          style={{ height: this.props.height }}
          onScrollToBottom={this.onScrollToBottom.bind(this)}
        >
          {list}
        </ScrollableContainer>
        <div
          style={{
            backgroundColor: Colors.Colors.faintBlack,
            color: theme.rawTheme.palette.primary3TextColor,
            lineHeight: '32px',
            paddingRight: Spacing.desktopGutterMini,
            paddingLeft: Spacing.desktopGutterMini,
            borderStyle: 'none none solid none',
            borderColor: this.context.muiTheme.rawTheme.palette.borderColor,
            borderWidth: 1
          }}
        >
          <FormattedMessage
            message={this.context.getIntlMessage('selectedCount')}
            num={selectedCount}
          />
          <div style={{ float: 'right' }}>
            <IconButton
              style={buttonStyle}
              onTouchTap={this.selectAll.bind(this)}
            >
              <Icons.ToggleCheckBox />
            </IconButton>
            <IconButton
              style={buttonStyle}
              onTouchTap={this.clearSelection.bind(this)}
            >
              <Icons.ToggleCheckBoxOutlineBlank />
            </IconButton>
          </div>
        </div>
      </Paper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/ListSelector.js